<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container
					*lowgileForm="'form86'; preventNavigation: true; let $formDirective; let form = form"
				>
					<ng-container *ngIf="screen.expense"
						><ng-container
							*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.expense.isLocked)) as $disabled"
						>
							<div
								class="layout-block"
								[style.align-items]="'start'"
								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.gap]="'1em'"
							>
								<div
									class="layout-block block"
									[style.flex]="'0 0 70%'"
									[style.align-items]="'start'"
									[style.gap]="'1em'"
								>
									<div
										class="layout-block"
										style="margin-top: 0"
										[style.align-items]="'inherit'"
										[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.--layout-column-count]="5"
										[style.gap]="'0.5em'"
									>
										<div
											[style.grid-column]="'span ' + (1)"
											style="display: inline-block"
										>
											<mat-form-field appearance="outline" class="fill">
												@let $fc_71_1 = getFormControl(screen.expense,
												'expenseDate', 71, $scope, $formDirective,
												$disabled, $ignoreValidations);
												<mat-label
													[innerHtml]="'Expense date' | escapeHtml"
												></mat-label>
												<input
													[required]="!$ignoreValidations"
													matInput
													[formControl]="$fc_71_1"
													[matDatepicker]="picker822277"
												/>
												<mat-datepicker-toggle
													matSuffix
													[for]="picker822277"
												></mat-datepicker-toggle>
												<mat-datepicker #picker822277></mat-datepicker>
												@for(error of $fc_71_1.errors ?? {} | keyvalue;
												track error.key) {
												<mat-error
													*ngIf="typeof error.value == 'string'"
													[innerHtml]="error.value | escapeHtml: 'safe'"
												/>
												}
											</mat-form-field>
										</div>
										<mat-form-field
											appearance="outline"
											style="width: 100%"
											[style.grid-column]="'span ' + (4)"
										>
											@let $fc_15_1 = getFormControl(screen.expense, 'name',
											15, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Name' | escapeHtml"
											></mat-label>
											<input
												#input_15
												[formControl]="$fc_15_1"
												type="text"
												matInput
												[required]="!$ignoreValidations"
											/>

											@for(error of $fc_15_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
									</div>
									<mat-divider
										[vertical]="false"
										style="margin-bottom: 26px"
									></mat-divider>
									<div
										class="layout-block"
										style="margin-top: 0"
										[style.align-items]="'inherit'"
										[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.--layout-column-count]="5"
										[style.gap]="'0.5em'"
									>
										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_76_1 = getFormControl(screen.expense,
											'currency', 76, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Currency' | escapeHtml"
											></mat-label>
											<mat-select
												[required]="!$ignoreValidations"
												[formControl]="$fc_76_1"
												[compareWith]="$compare"
												#select_76="matSelect"
												[lgFormComponent]="select_76"
												[lgFormValue]="screen.expense.currency"
												canSelectNullableOptions
											>
												@let emptyOption_76 = null; @if (emptyOption_76) {
												<mat-option [value]="emptyOption_76[0]"
													>{{ emptyOption_76[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (Llama.Currency.getChoices('$displayValue')); let $index = index"
													[value]="Llama.Currency.getEntry($option.id)"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_76_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.expense.currency)?.$isOther"
										>
											@let $fc_76_3 = getFormControl(screen.expense.currency,
											'$otherValue', 76, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Currency' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_76_3" />
										</mat-form-field>

										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_77_1 = getFormControl(screen.expense,
											'totalAmount', 77, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Total amount' | escapeHtml"
											></mat-label>
											<input
												#input_77
												[formControl]="$fc_77_1"
												type="text"
												matInput
												[required]="!$ignoreValidations"
											/>

											@for(error of $fc_77_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}

											<span matTextSuffix
												><span
													[innerHtml]="screen.expense.currency.label | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></span>
										</mat-form-field>

										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_78_1 = getFormControl(screen.expense,
											'vatAmount', 78, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'VAT amount included' | escapeHtml"
											></mat-label>
											<input
												#input_78
												[formControl]="$fc_78_1"
												type="text"
												matInput
												[required]="!$ignoreValidations"
											/>

											@for(error of $fc_78_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}

											<span matTextSuffix
												><span
													[innerHtml]="screen.expense.currency.label | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></span>
										</mat-form-field>

										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_79_1 = getFormControl(screen.expense,
											'tipAmount', 79, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Tip included' | escapeHtml"
											></mat-label>
											<input
												#input_79
												[formControl]="$fc_79_1"
												type="text"
												matInput
												[required]="!$ignoreValidations"
											/>

											@for(error of $fc_79_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}

											<span matTextSuffix
												><span
													[innerHtml]="screen.expense.currency.label | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></span>
										</mat-form-field>

										<mat-form-field
											appearance="outline"
											style="margin-left: 0.5em"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_80_1 = getFormControl(screen.expense,
											'isChargeable', 80, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Is chargeable' | escapeHtml"
											></mat-label>
											<mat-select
												[required]="!$ignoreValidations"
												[formControl]="$fc_80_1"
												[compareWith]="$compare"
												#select_80="matSelect"
												[lgFormComponent]="select_80"
												[lgFormValue]="screen.expense.isChargeable"
												canSelectNullableOptions
											>
												@let emptyOption_80 = null; @if (emptyOption_80) {
												<mat-option [value]="emptyOption_80[0]"
													>{{ emptyOption_80[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.chargeabilitiesOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_80_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.expense.isChargeable)?.$isOther"
										>
											@let $fc_80_3 =
											getFormControl(screen.expense.isChargeable,
											'$otherValue', 80, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Is chargeable' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_80_3" />
										</mat-form-field>
									</div>
									<div
										class="layout-block"
										style="margin-top: 0"
										[style.align-items]="'inherit'"
										[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.--layout-column-count]="3"
										[style.gap]="'0.5em'"
									>
										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_55_1 = getFormControl(screen.expense,
											'category', 55, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Category' | escapeHtml"
											></mat-label>
											<mat-select
												[required]="!$ignoreValidations"
												[formControl]="$fc_55_1"
												[compareWith]="$compare"
												#select_55="matSelect"
												[lgFormComponent]="select_55"
												[lgFormValue]="screen.expense.category"
												canSelectNullableOptions
											>
												@let emptyOption_55 = null; @if (emptyOption_55) {
												<mat-option [value]="emptyOption_55[0]"
													>{{ emptyOption_55[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (Llama.ExpenseCategory.getChoices('$displayValue')); let $index = index"
													[value]="Llama.ExpenseCategory.getEntry($option.id)"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_55_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.expense.category)?.$isOther"
										>
											@let $fc_55_3 = getFormControl(screen.expense.category,
											'$otherValue', 55, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Category' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_55_3" />
										</mat-form-field>

										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_56_1 = getFormControl(screen.expense, 'paidBy',
											56, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Paid By' | escapeHtml"
											></mat-label>
											<mat-select
												[required]="!$ignoreValidations"
												[formControl]="$fc_56_1"
												[compareWith]="$compare"
												#select_56="matSelect"
												[lgFormComponent]="select_56"
												[lgFormValue]="screen.expense.paidBy"
												canSelectNullableOptions
											>
												@let emptyOption_56 = null; @if (emptyOption_56) {
												<mat-option [value]="emptyOption_56[0]"
													>{{ emptyOption_56[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (Llama.ExpensePaidBy.getChoices('$displayValue')); let $index = index"
													[value]="Llama.ExpensePaidBy.getEntry($option.id)"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_56_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.expense.paidBy)?.$isOther"
										>
											@let $fc_56_3 = getFormControl(screen.expense.paidBy,
											'$otherValue', 56, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Paid By' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_56_3" />
										</mat-form-field>

										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_57_1 = getFormControl(screen.expense,
											'projectId', 57, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Project' | escapeHtml"
											></mat-label>
											<mat-select
												[required]="!$ignoreValidations"
												[formControl]="$fc_57_1"
												[compareWith]="$compare"
												#select_57="matSelect"
												[lgFormComponent]="select_57"
												[lgFormValue]="screen.expense.projectId"
												canSelectNullableOptions
											>
												@let emptyOption_57 = null; @if (emptyOption_57) {
												<mat-option [value]="emptyOption_57[0]"
													>{{ emptyOption_57[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.projectsOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.name | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_57_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.expense.projectId)?.$isOther"
										>
											@let $fc_57_3 = getFormControl(screen.expense.projectId,
											'$otherValue', 57, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Project' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_57_3" />
										</mat-form-field>
									</div>
									<div
										class="layout-block"
										style="margin-top: 0"
										[style.align-items]="'inherit'"
										[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.--layout-column-count]="1"
										[style.gap]="'0.5em'"
									>
										<mat-form-field
											appearance="outline"
											[style.grid-column]="'span ' + (1)"
										>
											@let $fc_64_1 = getFormControl(screen.expense,
											'description', 64, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Detailed description' | escapeHtml"
											></mat-label>
											<input
												#input_64
												[formControl]="$fc_64_1"
												type="text"
												matInput
											/>

											@for(error of $fc_64_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
									</div>
								</div>
								<div
									class="layout-block vertical"
									[style.flex]="'0 0 30%'"
									[style.align-items]="'center'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="true"
										><ng-container
											*ngFor="let receipt of screen.expense.receipts; let receiptIndex = index; trackBy: trackByAutomatic"
										>
											<ng-container
												*lowgileScope="receipt; as: 'receipt'; let $scope"
											>
												<ng-container
													*lowgileScope="receiptIndex; as: 'receiptIndex'; let $scope"
												>
													<Llama-OpenReceiptButtonInclude
														[$formDirective]="$formDirective"
														[$disabled]="$disabled"
														[$ignoreValidations]="$ignoreValidations"
														[receiptId]="receipt.id"
													>
													</Llama-OpenReceiptButtonInclude>
												</ng-container>
											</ng-container> </ng-container
									></ng-container>
								</div>
							</div>
							<div
								class="layout-block vertical"
								style="margin-top: 1.5rem"
								[style.align-items]="'end'"
								[style.gap]="'1em'"
							>
								<ng-container
									*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.expense.projectId || form.invalid)) as $disabled"
								>
									<button
										mat-raised-button
										class="has-click-handler"
										color="basic"
										(click)="handler_ButtonBlock_21_click_$adhoc_0($event, { form })"
										[disabled]="$disabled"
									>
										<mat-icon>{{'check'}}</mat-icon
										><span
											[innerHtml]="'Verify' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</button>
								</ng-container>
								<ng-container *ngIf="!screen.expense.projectId"
									><span
										style="color: red; font-style: italic"
										[innerHtml]="'Please select the project to continue' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></ng-container>
							</div>
						</ng-container>
					</ng-container>
				</ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
